import React from 'react';

interface Props {
  /**
   * The id of the component that failed to render.
   */
  componentId: string;

  /**
   * The instance id of the component that failed to render.
   */
  instanceId?: string;
  /**
   * An optional error message.
   */
  errorMessage?: string;
}

/**
 * This is a static error page that doesn't have dependency of any modules to
 * be rendered (e.g. intl, theme, context...). This component intentionally uses inline
 * styles and static text to avoid any dependency on features that might be the cause of
 * the exception.
 *
 * @author Dolan Halbrook
 */
const QuiltComponentError: React.FC<React.PropsWithChildren<Props>> = ({
  componentId,
  instanceId,
  errorMessage
}) => {
  return (
    <>
      <style>
        {`
          .lia-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100dvh;
          }

          .lia-title {
            color: #707070;
            font-size: 16px;
            line-height: 1.5;
            font-weight: 700;
            margin-bottom: 4px;
            text-align: center;
          }

          .lia-description {
            color: #707070;
            font-size: 14px;
            line-height: 1.5;
            font-weight: 400;
            text-align: center;
          }
        `}
      </style>
      <div className="lia-container">
        <span className="lia-title">Error rendering component</span>
        <small className="lia-description">Component ID: {instanceId ?? componentId}</small>
        <small className="lia-description">
          {errorMessage ?? 'Check the browser console for error details.'}
        </small>
      </div>
    </>
  );
};

export default QuiltComponentError;
